module.exports = __webpack_public_path__ + "img/firedoor.0624e88c.png";